import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';

export const newsAppHeader = ({ appHeaderProps }) => ({
  ...BLOCKS.appHeader,
  attributes: appHeaderProps,
});
